import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getQueryParams } from '@browsing/utils';
export var useQuery = function () {
    var search = useLocation().search;
    return useMemo(function () { return getQueryParams(search); }, [search]);
};
